import { render, staticRenderFns } from "./ShopIcon.vue?vue&type=template&id=697f68e5&"
import script from "./ShopIcon.vue?vue&type=script&lang=js&"
export * from "./ShopIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports